import type {IModelPricingStore} from "./interfaces/IModelPricingStore";
import type {TModelPricingStoreDefinition} from "./types/TModelPricingStoreDefinition";

import {useCrudStore} from "@/stores/CrudStore/CrudStore";
import {IModelPricing} from "@/stores/ModelPricingStore/interfaces/IModelPricing";
import {IModelPricingUpdate} from "@/stores/ModelPricingStore/interfaces/IModelPricingUpdate";

export const useModelPricingSore = () =>
    useCrudStore<IModelPricing, IModelPricing, IModelPricingUpdate, TModelPricingStoreDefinition, IModelPricingStore>({
        storeId: 'modelPricingStore',
        route: '/portal/{guid}/models',
        initialize: true,
        langSection: 'stores.models'
    });
